import { render, staticRenderFns } from "./MenuWidget.vue?vue&type=template&id=c9f667b4&"
import script from "./MenuWidget.vue?vue&type=script&lang=js&"
export * from "./MenuWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports